import React from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';

const Insights = () => {
  return (
    <div className="page-container">
      <Navbar />
      <main className="content-wrapper">
        <section className="page-header">
          <h1>Legal Insights & Market Analysis</h1>
          <p>Understanding India's Legal Technology Landscape</p>
        </section>
        
        <section className="insights-grid">
          <div className="insight-card">
            <h2>Market Size & Growth</h2>
            <div className="post-list">
              <div className="post-item">
                <h3>Legal Services Market</h3>
                <p>India's legal services market valued at $2.5B in 2023, projected to reach $3.37B by 2030</p>
              </div>
              <div className="post-item">
                <h3>Digital Transformation</h3>
                <p>₹721 Billion e-Courts Phase III investment, with 18,000+ courts being digitized</p>
              </div>
            </div>
          </div>
          
          <div className="insight-card">
            <h2>Legal System Statistics</h2>
            <div className="post-list">
              <div className="post-item">
                <h3>Case Management</h3>
                <p>52M+ pending cases in Indian courts with 40M+ new cases filed annually</p>
              </div>
              <div className="post-item">
                <h3>Legal Access Gap</h3>
                <p>Only 1 lawyer per 1,500 citizens with 70% legal processes still manual</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Insights; 